import loadable from '@loadable/component';

export const SearchInternshipRefinementsLoadable = loadable(
  () => import('./SearchInternshipRefinements'),
  { resolveComponent: (module) => module.SearchInternshipRefinements },
);
